export const clientID = {client_id: 'web_app'}
export const responseType = {response_type: 'code'}
export const redirectURI = {redirect_uri: ''}
export const grantType = {grant_type: 'authorization_code'}
export const clientSecret = {client_secret: '1234'}
export const code = {code: ''}

export const environment_dev = {
  production: false,
  logging: {
    "logLevels": [
      {
        "loggerName": "root",
        "logLevel": "INFO"
      }
    ],
    "localStorageAppender": {
      "localStorageKey": "deviceLogs",
      "maxMessages": 2000,
      "threshold": "INFO"
    },
    "browserConsoleAppender": {
      // "threshold": "OFF"
      "threshold": "DEBUG"
    }
  },
  appType: 'IONIC_APP',
  appTitle: 'Printix App',
  appLink: 'printixapp://',
  appLogo: 'assets/img/logo/logo-img.png',
  mainDBName: 'data.mainDB',
  tableNameKeyValue: 'printixapp_key_value',
  endpointLogInResponse_WepApp: '?response_type=code&client_id=web_app&redirect_uri=https://',
  endpointLogInResponse_Native: '?response_type=code&client_id=web_app&redirect_uri=',
  endPointAuthorization: 'grant_type=authorization_code&client_id=web_app&client_secret=1234&redirect_uri=',
  authorizationQueryParams: [grantType, clientID, clientSecret, redirectURI, code],
  signInQueryParams: [clientID, responseType, redirectURI],

    // --------------------------- UnActive Endpoints ---------------------------------------------------- //

    // logoUrl: '/assets/img/logo/logo-img.png',
    // navParamLogOut: 'logout',
    // enumerationUrl: 'https://api.printix.net/v1/enumerations/PrinterType',

 /********************************************************************************************************************** */
  /** DEV */
  /********************************************************************************************************************** */
  appEndpoint: 'https://app.devenv.printix.net',
  checkServerHealth: 'https://api.devenv.printix.net/manage/health',
  internalTestWaitTime: 'https://api.devenv.printix.net/internal/testing/wait/',
  internalTestReturnSetStatusCode: 'https://api.devenv.printix.net/internal/testing/status/',
  endpointApi: 'https://api.devenv.printix.net',
  endpointCodeExchange: 'https://auth.devenv.printix.net/oauth/token',
  endpointLogOut: 'https://auth.devenv.printix.net/oauth/revoke?token=',
  endpointLogInTenantLess: 'https://auth.devenv.printix.net/oauth/authorize?response_type=code&client_id=web_app&redirect_uri=',
  endpointLogInWepAppTenant: 'https://auth.devenv.printix.net/oauth/authorize/tenant/',
  endpointLogInMS: 'https://auth.devenv.printix.net/identity-providers/azure/signin?redirect_uri=',
  endpointLogInGoogle: 'https://auth.devenv.printix.net/identity-providers/google/signin?redirect_uri=',
  endpointGetTenantUser: 'https://api.devenv.printix.net/v1/users/me',
  endpointFindTenant: 'https://api.devenv.printix.net/v1.2/find/',
  environmentState: 'devenv'

  // --------------------------- UnActive Endpoints ---------------------------------------------------- //

  // endpointTenantList: 'https://api.devenv.printix.net/v1/tenants',
  // endpointError: 'https://api.devenv.printix.net',
  // endpointToken: 'https://auth.devenv.printix.net/oauth/token',
  // endpointRecoverPassword: 'https://auth.devenv.printix.net/recover/access',
  // endpointLogInVertical: 'https://auth.devenv.printix.net/identity-providers/vertical/signin?redirect_uri=',
  // endpointLogInOneLogin: 'https://auth.devenv.printix.net/identity-providers/onelogin/signin?tenant_domain=',
  // endpointLogInOkta: 'https://auth.devenv.printix.net/identity-providers/okta/signin?tenant_domain=',
  // directorySnippet: '&directory=printix-dev&redirect_uri=',
};